import {axiosInstance} from './AxiosInstance'

export const getData = async(url:string)=>{
  try {
    const res = await axiosInstance.get(url);
    return res?.data?.data;
  } catch (error) {
    return error
  }
}